export default class Branch {

    constructor(data) {
        this.id = null;
        this.name = null;
        this.number = null;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/branch.model.js